import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ServiceManagePage } from './service-manage.page';

const routes: Routes = [
  {
    path: '',
    component: ServiceManagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServiceManagePageRoutingModule {}
